import React, { useState, useEffect } from 'react';
import '../../styles/Scroll.css';
export function ScrollToTop() {
    const [isVisible, setIsVisible] = useState(false);

    // Afficher le bouton quand on descend de 300px
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

// IMPORTANT : Si ce n'est pas visible, on ne renvoie RIEN
    if (!isVisible) {
        return null;
    }
    return (
        <div className="scroll-to-top">
            {isVisible && (
                <div onClick={scrollToTop} className="back-to-top-button">
                    <span className="arrow-up"></span>
                </div>
            )}
        </div>
    );
}